import { useCurrentClient } from "../../context/Client";

function useCenterParcs() {
  const client = useCurrentClient();

  return { isCenterParcsClient: client?.code === "center-parcs" };
}

export { useCenterParcs };
